<template>
    <div id="charg">
        <div class="charg_p">
            <!-- <div>收费列表</div> -->
            <div class="right">
                <el-date-picker
                        :class="{dateclass:active}"
                        v-model="chartTimeValue"
                        :clearable="false"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="charg_date"
                        style="overflow: hidden;margin-bottom: -15px;line-height: 10px;"
                ></el-date-picker>
                <el-input :class="{inputclass:active}" v-model="payer" placeholder="请输入代付人姓名"></el-input>
                <el-input :class="{inputclass:active}" v-model="input" placeholder="请输入姓名或手机号"></el-input>
                <el-button type="primary" class="el-icon-search" @click="searchButton"></el-button>
                <el-button type="primary" class="el-icon-download" @click="downLoad"></el-button>
            </div>
        </div>
        <template>
            <el-table
                    border
                    :data="chargeList"
                    style="width: 98%;margin-left: 5px"
                    @row-click="openDetails"
                    :header-cell-style="tableHeaderColor"
            >
                <el-table-column prop="orderNumber" label="订单号" width="auto"></el-table-column>
                <el-table-column prop="patientBaseEntity.name" label="姓名" width="auto"></el-table-column>
                <el-table-column prop="patientBaseEntity.gender" label="性别" width="auto"></el-table-column>
                <!--<el-table-column prop="patientBaseEntity.age" label="周岁" width="auto"></el-table-column>-->
                <el-table-column prop="patientBaseEntity.mobileNumber" label="手机号"></el-table-column>
                <el-table-column prop="orderType" label="订单类型"></el-table-column>
                <el-table-column prop="totalCost" label="总金额（元）" width="auto"></el-table-column>
                <el-table-column prop="orderDate" label="日期"></el-table-column>
                <!--<el-table-column prop="orderStatus" label="状态"-->
                <!--:filters="[{ text: '待支付', value: 0 },{ text: '已支付', value: 1}]"-->
                <!--:filter-method="filterTag" filter-placement="bottom-end">-->
                <el-table-column prop="orderStatus" label="状态">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.orderStatus === 0 ? 'danger' : 'success'"
                                disable-transitions
                        >{{scope.row.orderStatus==0 ? '待支付':'已支付'}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="paymentType" label="支付类型">
                    <template slot-scope="scope" v-if="scope.row.paymentType!=-1">
                        <el-tag :type="scope.row.paymentType === 4 ? 'danger' : 'success'" disable-transitions>
                            {{scope.row.paymentType==0 ? '现金支付':(scope.row.paymentType==1 ?
                            '微信支付':(scope.row.paymentType==2 ? '医保卡支付':(scope.row.paymentType==3 ?
                            '银行卡支付':(scope.row.paymentType==4 ? '代付':'待支付'))))}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="payerName" label="代付人"></el-table-column>
                <el-table-column prop="orderDateTime" label="开单时间"></el-table-column>
				<el-table-column prop="paymentDateTime" label="支付时间"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template scope="scope">
                        <el-button
                                type="text"
                                size="small"
                                @click="checkClick(scope.row)"
                                v-if="scope.row.orderStatus!=0"
                        >查看详情
                        </el-button>
                        <el-button type="text"
                                   size="small"
                                   @click.stop="deleteOrder(scope.row)"
                        v-if="scope.row.orderStatus==0">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="Current"
                    :page-size="this.Size"
                    layout="total,prev, pager, next, jumper"
                    :total="this.total"
            ></el-pagination>
        </div>
    </div>
</template>
<style scoped>
    /*.charg_p div[data-v-82c28590] {*/
    /*overflow:hidden;*/
    /*}*/

    .el-button--primary {
        color: #fff;
        background-color: rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }

    .el-button--primary.is-disabled,
    .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus,
    .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }

    .el-button--primary:focus,
    .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }

    .el-table__body tr,
    .el-table__body td {
        padding: 0;
        height: 40px;
    }

    #charg {
        width: 100%;
        padding-bottom: 50px;
        background-color: white;
    }

    .block {
        margin-top: 20px;
        padding-left: 33%;
    }

    .charg_p {
        border-bottom: 1px solid #e7e7e7;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.68);
        line-height: 70px;
        padding: 0 20px 0 10px;
    }

    .charg_p div {
        display: inline-block;
    }

    .right {
        float: right;
    }

    .inputclass {
        width: 200px !important;
    }
</style>
<script>
    import {formatDate} from "../../common/date";

    export default {
        data() {
            return {
                timer: null,
                //   timeOut: null,
                dataList: {},
                active: true,
                total: 0,
                chargeList: [],
                chargeListDownload: [],
                state: "",
                Current: 1,
                Size: 10,
                currentPage: 1,
                payer: "",
                input: "",
                charg_date: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit("pick", [start, end]);
                            }
                        }
                    ]
                },
                chartTimeValue: [Date.now(), Date.now()]
            };
        },
        mounted: function () {
            let sessionData = JSON.parse(sessionStorage.getItem("chargeTime"));
            if (sessionData) {
                this.chartTimeValue = [];
                this.chartTimeValue.push(sessionData.startDate);
                this.chartTimeValue.push(sessionData.endDate);
                this.dataList = {
                    startDate: formatDate(this.chartTimeValue[0], "yyyy-MM-dd"),
                    endDate: formatDate(this.chartTimeValue[1], "yyyy-MM-dd")
                };
                this.getinfo();
                this.timer = setInterval(this.getinfo, 60000);
            } else {
                this.dataList = {
                    startDate: formatDate(this.chartTimeValue[0], "yyyy-MM-dd"),
                    endDate: formatDate(this.chartTimeValue[1], "yyyy-MM-dd")
                };
                this.getinfo();
                this.timer = setInterval(this.getinfo, 60000);
            }
        },
        beforeDestroy() {
            console.log("关闭计时器: ", this.timer);
            clearInterval(this.timer);
        },
        methods: {
            getinfo: function () {
                this.$axios({
                    url:
                        "/api/order/" +
                        0 +
                        "/pageNumber/" +
                        this.Current +
                        "/size/" +
                        this.Size,
                    method: "POST",
                    data: this.dataList,
                    showLoading: false
                })
                    .then(res => {
                        console.log(res);
                        this.chargeList = res.data.data.content;
                        this.total = res.data.data.totalElements;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getdownLoadInfo: function () {
                console.log(this.dataList);
                this.$axios({
                    url: "/api/order/" + 0 + "/pageNumber/" + 1 + "/size/" + 10000,
                    method: "POST",
                    data: this.dataList
                })
                    .then(res => {
                        console.log(res);
                        this.chargeListDownload = res.data.data.content;
                        return this.chargeListDownload;
                        //                this.total = res.data.data.totalElements;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            deleteOrder: function (row) {
                // console.log(row)
                let orderNumber = row.orderNumber;
                this.$confirm("订单信息非常重要，是否确定删除?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                })
                    .then(() => {
                        this.$axios({
                            url: "/api/order/deleteOrder/" + orderNumber,
                            method: "DELETE"
                        }).then(res => {
                            if (res.data.code === 200) {
                                this.getinfo();
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                            } else {
                              this.$alert(res.data.msg)
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            searchButton: function () {
                this.Current = 1;
                this.dataList = {};
                if (this.payer !== "") {
                    this.dataList.payerName = this.payer;
                } else {
                    this.dataList.payerName = undefined;
                }
                if (this.input !== "") {
                    let frist = this.input.split("")[0];
                    if (frist == 1) {
                        this.dataList.mobileNumber = this.input;
                        this.dataList.startDate = formatDate(
                            this.chartTimeValue[0],
                            "yyyy-MM-dd"
                        );
                        this.dataList.endDate = formatDate(
                            this.chartTimeValue[1],
                            "yyyy-MM-dd"
                        );
                        this.getinfo();
                    } else {
                        this.dataList.patientName = this.input;
                        this.dataList.startDate = formatDate(
                            this.chartTimeValue[0],
                            "yyyy-MM-dd"
                        );
                        this.dataList.endDate = formatDate(
                            this.chartTimeValue[1],
                            "yyyy-MM-dd"
                        );
                        this.getinfo();
                    }
                } else {
                    // this.dataList = {};
                    this.dataList.mobileNumber = undefined;
                    this.dataList.patientName = undefined;
                    this.dataList.startDate = formatDate(
                        this.chartTimeValue[0],
                        "yyyy-MM-dd"
                    );
                    this.dataList.endDate = formatDate(
                        this.chartTimeValue[1],
                        "yyyy-MM-dd"
                    );
                    let chargeJson = JSON.stringify(this.dataList);
                    sessionStorage.setItem("chargeTime", chargeJson);
                    this.getinfo();
                }
            },
            downLoad: function () {
                this.dataList = {};
                this.dataList.startDate = formatDate(
                    this.chartTimeValue[0],
                    "yyyy-MM-dd"
                );
                this.dataList.endDate = formatDate(this.chartTimeValue[1], "yyyy-MM-dd");
                let chargeJson = JSON.stringify(this.dataList);
                sessionStorage.setItem("chargeTime", chargeJson);

                this.$axios({
                    url: "/api/order/" + 0 + "/pageNumber/" + 1 + "/size/" + 10000,
                    method: "POST",
                    data: this.dataList
                })
                    .then(res => {
                        console.log(res);
                        var chargeListDownload = res.data.data.content;

                        for (var li in chargeListDownload) {
                            chargeListDownload[li].name =
                                chargeListDownload[li].patientBaseEntity.name;
                            chargeListDownload[li].gender =
                                chargeListDownload[li].patientBaseEntity.gender;
                            chargeListDownload[li].age =
                                chargeListDownload[li].patientBaseEntity.age;
                            chargeListDownload[li].orderStatus =
                                chargeListDownload[li].orderStatus == 0 ? "未支付" : "已支付";
                            switch (chargeListDownload[li].paymentType) {
                                case 0:
                                    chargeListDownload[li].paymentType = "现金支付";
                                    break;
                                case 1:
                                    chargeListDownload[li].paymentType = "微信支付";
                                    break;
                                case 2:
                                    chargeListDownload[li].paymentType = "医保卡";
                                    break;
                                case 3:
                                    chargeListDownload[li].paymentType = "银行卡";
                                    break;
                                case 4:
                                    chargeListDownload[li].paymentType = "代付";
                                    break;
                            }
                        }
                        this.chargeListDownload = chargeListDownload;
                        //兼容ie10哦！
                        require.ensure([], () => {
                            const {
                                export_json_to_excel
                            } = require("../../vendor/Export2Excel.js"); //引入文件
                            const tHeader = [
                                "订单号",
                                "姓名",
                                "性别",
                                "周岁",
                                "订单类型",
                                "总金额（元）",
                                "日期",
                                "状态",
                                "支付类型"
                            ]; //将对应的属性名转换成中文
                            // const tHeader = [];

                            const filterVal = [
                                "orderNumber",
                                "name",
                                "gender",
                                "age",
                                "orderType",
                                "totalCost",
                                "orderDate",
                                "orderStatus",
                                "paymentType"
                            ]; //table表格中对应的属性名
                            const list = this.chargeListDownload;
                            const data = this.formatJson(filterVal, list);
                            var filename =
                                "收费列表" +
                                formatDate(this.chartTimeValue[0], "yyyy-MM-dd") +
                                "-" +
                                formatDate(this.chartTimeValue[1], "yyyy-MM-dd");
                            export_json_to_excel(tHeader, data, filename);
                        });
                        //                this.total = res.data.data.totalElements;
                    })
                    .catch(err => {
                        console.log(err);
                        //                clearTimeout(this.timeOut);
                    });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]));
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.Size = val;
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.Current = val;
                this.getinfo();
            },
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return "background-color:#f2f2f2;color: #a4a7af;";
                }
            },
            filterHandler(value, row, column) {
                const property = column["property"];
                return row[property] === value;
            },
            //点击一行跳转
            openDetails(row) {
                // if(row.orderType == '新诊挂号' || row.orderType == '复诊挂号'){
                //     this.$message({
                //         type: 'warning',
                //         message: '患者手机端支付款！'
                //     });
                //     return;
                // }
                if (row.orderStatus == 0) {
                    let data = {
                        orderNumber: row.orderNumber,
                        patientId: row.patientBaseEntity.id,
                        orderType: row.orderType
                    };
                    data = JSON.stringify(data);
                    this.$router.push({path: "./chargeDetail", query: {data: data}});
                }
            },
            //查看详情
            checkClick: function (val) {
                console.log(val);
                if (val.orderStatus !== 0) {
                    let Data = val.orderNumber;
                    let patientId = val.patientBaseEntity.id;
                    this.$router.push({path: "./chargeDetail", query: {Data: Data, patientId: patientId}});
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// charge_list.vue?7887680f